import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { CategoryPathingData } from '../category-pathing-types';
import { loadCategoryPathingData, loadCategoryPathingDemoData } from './amc-data-loader';

export const useCategoryPathingData = (
  amcInstanceId: string | undefined,
  cid: string | undefined,
  reportEndDate?: string
): ReturnType<typeof useQuery<CategoryPathingData>> =>
  useQuery({
    queryKey: ['categoryPathingData', amcInstanceId, cid, reportEndDate],
    queryFn: () => {
      if (!amcInstanceId || !cid) throw new Error('Missing AMC instance id or company');
      return loadCategoryPathingData(amcInstanceId, cid, reportEndDate);
    },
    enabled: Boolean(amcInstanceId && cid),
    // Keep the prior period's data on screen while a newly-selected period loads, so the
    // period picker and dashboard don't flash out.
    placeholderData: keepPreviousData
  });

// Static demo dataset for the hidden comparison route. `enabled` lets the caller keep the
// hook mounted (Rules of Hooks) while only fetching in demo mode.
export const useCategoryPathingDemoData = (
  enabled: boolean
): ReturnType<typeof useQuery<CategoryPathingData>> =>
  useQuery({
    queryKey: ['categoryPathingDemoData'],
    queryFn: loadCategoryPathingDemoData,
    enabled
  });
